 import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  AppBar,
  Toolbar,
  Typography,
  Drawer,
  List,
  ListItem,
  ListItemText,
  ListItemIcon,
  Collapse,
  Avatar,
  IconButton,
  Badge,
} from "@mui/material";
import {
  Home as HomeIcon,
  Apartment as ApartmentIcon,
  Category as CategoryIcon,
  Person as PersonIcon,
  Map as MapIcon,
  Assessment as AssessmentIcon,
  Apps as AppsIcon,
} from "@mui/icons-material";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";

const AdminLayout = ({ children, title = "Dashboard" }) => {
  const navigate = useNavigate();
  const [openSublist, setOpenSublist] = useState(null);

  // Récupérez les informations de l'utilisateur depuis localStorage ou contexte
  const fullName = localStorage.getItem("fullName") || "Utilisateur non connecté";
  const role = localStorage.getItem("role") || "Non défini";
  const profileImage = localStorage.getItem("profileImage") || "https://via.placeholder.com/100";
  const initials = fullName.split(" ").map(n => n[0]).join("").toUpperCase() || "A";

  const handleSublistToggle = (index) => {
    setOpenSublist((prev) => (prev === index ? null : index));
  };

  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("fullName");
    localStorage.removeItem("isAuthenticated");
    localStorage.removeItem("profileImage");
    navigate("/loginadmin");
  };

  return (
    <Box sx={{ display: "flex" }}>
      {/* Sidebar */}
      <Drawer
        variant="permanent"
        sx={{
          width: 240,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
            position: "fixed",
            backgroundColor: "#003366",
            color: "white",
          },
        }}
      >
        <Box sx={{ padding: 2, textAlign: "center" }}>
          <Typography variant="h6" sx={{ color: "white" }}>
            KEURGUI
          </Typography>
          
          <img
            src={profileImage}
            alt={fullName}
            style={{
              width: 80,
              height: 80,
              borderRadius: "50%",
              objectFit: "cover",
              display: "block",
              margin: "16px auto 0",
            }}
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "https://via.placeholder.com/80";
            }}
          />

          <Typography variant="body1" sx={{ marginTop: 1 }}>
            {fullName}
          </Typography>
          <Typography variant="body2" color="textSecondary">
            {role}
          </Typography>
        </Box>

        <List>
          <h6 style={{ marginLeft: "16px", color: "white" }}>General</h6>
          <div
            style={{
              height: "1px",
              backgroundColor: "red",
              marginLeft: "16px",
              marginRight: "16px",
              borderRadius: "2px",
            }}
          ></div>

          {[
            {
              label: "Tableau de bord",
              path: "/admin",
              icon: <HomeIcon sx={{ color: "green" }} />,
            },
            {
              label: "Propriété",
              subItems: [
                { label: "Propriétés a vendre", path: "/adminpv" },
                { label: "Propriétés a louer", path: "/adminpa" },
                { label: "Ajouter une proprite", path: "/ajoutp" },
              ],
              icon: <ApartmentIcon sx={{ color: "yellow" }} />,
            },
            {
              label: "Types",
              subItems: [
                { label: "Appartement", path: "/apt" },
                { label: "Bureau_commerce", path: "/bureau_commerce" },
                { label: "Hotel_restaurant", path: "/hotel_restaurant" },
                { label: "Immeuble", path: "/immeuble" },
                { label: "Residence", path: "/residence" },
                { label: "Studio_chambre", path: "/studio_chambre" },
                { label: "Villa_maison", path: "/villa_maison" },
                { label: "Terrain", path: "/terrain" },
              ],
              icon: <CategoryIcon sx={{ color: "red" }} />,
            },
            {
              label: "Agents",
              subItems: [
                { label: "Tous les agents", path: "/agnts" },
                { label: "Ajouter un agent", path: "/add-agent" },
                { label: "Facture de l'agent", path: "/types/ajouter" },
              ],
              icon: <PersonIcon sx={{ color: "teal" }} />,
            },
            {
              label: "Utilisateurs",
              path: "/users",
              icon: <PersonIcon sx={{ color: "fuchsia" }} />,
            },
            {
              label: "Carte",
              path: "/carte",
              icon: <MapIcon sx={{ color: "blue" }} />,
            },
            {
              label: "Rapports",
              path: "/rapports",
              icon: <AssessmentIcon sx={{ color: "orange" }} />,
            },
            {
              label: "Application",
              path: "/application",
              icon: <AppsIcon sx={{ color: "salmon" }} />,
            },
          ].map((item, index) => (
            <React.Fragment key={item.label}>
              <ListItem
                button
                onClick={() =>
                  item.subItems ? handleSublistToggle(index) : handleNavigation(item.path)
                }
              >
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
                {item.subItems ? (
                  openSublist === index ? <ExpandLess /> : <ExpandMore />
                ) : null}
              </ListItem>

              {item.subItems && (
                <Collapse in={openSublist === index} timeout="auto" unmountOnExit>
                  <List component="div" disablePadding>
                    {item.subItems.map((subItem) => (
                      <ListItem
                        button
                        sx={{ pl: 4 }}
                        key={subItem.label}
                        onClick={() => handleNavigation(subItem.path)}
                      >
                        <ListItemText primary={subItem.label} />
                      </ListItem>
                    ))}
                  </List>
                </Collapse>
              )}
            </React.Fragment>
          ))}
        </List>
      </Drawer>

      {/* Main Content */}
      <Box sx={{ flexGrow: 1, bgcolor: "#f5f5f5" }}>
        {/* Topbar */}
      <AppBar
  position="static"
  sx={{
    bgcolor: "#003366",
    marginLeft: '20px', // Décalage pour laisser la place à la sidebar
    // width: 'calc(100% - 240px)' // Optionnel : pour éviter qu'elle déborde à droite
  }}
>
  <Toolbar>
    <Typography variant="h6" sx={{ flexGrow: 1, color: "white" }}>
      {title}
    </Typography>
    <IconButton color="inherit" onClick={handleLogout}>
      <ExitToAppIcon />
    </IconButton>

    <Avatar sx={{ bgcolor: "#FFA726", marginLeft: 2 }}>
      {initials}
    </Avatar>
     
  </Toolbar>
</AppBar>


        {/* Contenu enfant */}
        <Box sx={{ p: 3 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;